import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatText } from "@ui/format";
import { Button, List } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export interface StepFields {}

interface Props extends AbstractStepProps {
	durationYears: number;
	sumPrice: number;
}

export class Result extends AbstractStep<StepFields, Props> {
	protected renderContent(): ReactNode {
		const { durationYears, sumPrice } = this.props;

		return (
			<>
				<Card.Header className="bg-secondary-gradient text-white text-center">
					<div className="h3 font-weight-normal mt-2 mb-3">
						Az igényelt biztonság díja
						<br />
						<mark className="font-weight-bold bg-white text-primary text-nowrap px-2 py-1 mx-1 my-1 d-inline-block">
							{durationYears} éves
						</mark>{" "}
						szerződés esetén
					</div>
					<div className="display-1 mb-0 font-weight-bold">{formatText(sumPrice, "ft")}</div>
					<div className="display-4 mb-3">havi díjtól</div>
					<div className="small">
						Beállításaid alapján ilyen kondiciókkal
						<br /> érhető el a biztosítási védelem
					</div>
				</Card.Header>
				<Card.Body className="d-flex flex-column">
					<div className="h4 text-center mt-auto">
						A részletes eredményeidet
						<br /> email-ben küldjük el
					</div>
					<List itemStyle="tick" variant="primary" className="mb-auto">
						<List.Item>Pontosan milyen védelmet kapsz ezen összegért? Hogyan működik?</List.Item>
						<List.Item>
							<strong>Milyen esetben kapod meg a kifizetést a biztosítótól?</strong>
						</List.Item>
						<List.Item>
							<strong>Szakértőink segítenek</strong> bármilyen felmerülő kérdésedben
						</List.Item>
					</List>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button type="submit" icon={<FontAwesomeIcon icon={fasArrowRight} />}>
						Kérem az eredményeimet
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Result";
	}
}
